module.exports = __webpack_public_path__ + "img/text-pic.bbd6c300.png";